module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 h-100 justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "col-3 login-part"
  }, [(_vm.dataReady) ? _c('h1', {
    on: {
      "click": _vm.createAccount
    }
  }, [_vm._v("Chargement en cours...")]) : _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_c('div', {
    staticClass: "bkg-img d-flex align-items-center justify-content-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo_v2/talent-blanc-couleur.svg"),
      "alt": "Talent"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab7239d0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/authentication.vue.html
// module id = RQw6
// module chunks = 2